export default "__VITE_ASSET__CyiI9IpR__"